const shadows = {
  default: '20px 20px 70px rgba(0, 23, 233, 0.1)',
}

export default shadows
